module.exports = __webpack_public_path__ + "img/SouthAfrica.ea09383a.png";